// extracted by mini-css-extract-plugin
export default {"breakdown-content":"components-parity-charts-chart-variance-module__breakdown-content"};